import ShowMore from './ShowMore';

document.addEventListener('DOMContentLoaded', function () {
    const els = document.querySelectorAll('.show-more');

    for (let el of els) {
            new ShowMore(el);
    }
});
